/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListSuiteVersions } from "../../funcs/llmEvalsListSuiteVersions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalSuiteVersionsRequest$inboundSchema,
};

export const tool$llmEvalsListSuiteVersions: ToolDefinition<typeof args> = {
  name: "llm-evals-list-suite-versions",
  description: `List eval suite versions

Returns immutable versions for an eval suite, including each version manifest.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListSuiteVersions(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
